export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/chat": [3],
		"/defend": [4],
		"/demo_agents": [5],
		"/demo_report_checker": [6],
		"/demo_workspace": [7],
		"/draft_au": [9],
		"/draft_ireland": [10],
		"/draft_sai": [12],
		"/draft_sa": [11],
		"/draft": [8],
		"/early-access": [13],
		"/innovate_uk": [14],
		"/login": [15],
		"/mcp/authorize": [16],
		"/notify": [17],
		"/partner": [18],
		"/profile": [19],
		"/project_sorter": [20],
		"/qualify_ireland": [22],
		"/qualify_sa": [23],
		"/qualify": [21],
		"/realtime": [24],
		"/report_checker": [25],
		"/research": [26],
		"/review": [27],
		"/script": [28],
		"/signup": [29],
		"/subscriptions": [30],
		"/success": [31],
		"/superadmin": [32],
		"/terms": [33]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';